export type QuizDataFormat = {
  question: string;
  possibleAnswers: string[];
  correctAnswer: string;
};

export const quizData = [
  {
    question: 'Which of the following is not an official language of the UN? ',
    possibleAnswers: ['Hindi', 'Arabic', 'Chinese', 'Russian'],
    correctAnswer: 'Hindi',
  },
  {
    question: 'Which country consumes the most chocolate per capita?',
    possibleAnswers: ['United States', 'Germany', 'Austria', 'Switzerland'],
    correctAnswer: 'Switzerland',
  },
  {
    question: 'Which of Shakespeare’s plays is the longest?',
    possibleAnswers: ['Hamlet', 'Macbeth', 'Romeo and Juliet', 'King Lear'],
    correctAnswer: 'Hamlet',
  },
  {
    question: 'The Statue of Liberty was given to the US by which country?',
    possibleAnswers: ['Great Britain', 'France', 'Russia', 'Italy'],
    correctAnswer: 'France',
  },
  {
    question: 'What is the Twitter bird’s official name?',
    possibleAnswers: ['Mark', 'Paul', 'Larry', 'Charles'],
    correctAnswer: 'Larry',
  },
  {
    question: 'What year was the very first model of the iPhone released?',
    possibleAnswers: ['2003', '2005', '2006', '2007'],
    correctAnswer: '2007',
  },
  {
    question: 'How many hearts does an octopus have?',
    possibleAnswers: ['2', '3', '5', '8'],
    correctAnswer: '3',
  },
  {
    question: 'The hit US comedy "Friends" had how many seasons?',
    possibleAnswers: ['12', '10', '8', '4'],
    correctAnswer: '10',
  },
  {
    question: 'What is the national dish of Slovakia?',
    possibleAnswers: ['Bryndzové halušky', 'Ceviche', 'Bigos', 'Prežganka'],
    correctAnswer: 'Bryndzové halušky',
  },
  {
    question: 'Which of the following is not a Marvel character?',
    possibleAnswers: ['Abraxas', 'Blackheart', 'ZZZAX', 'Black Adam'],
    correctAnswer: 'Black Adam',
  },
  {
    question: 'What country has the most natural lakes?',
    possibleAnswers: ['Canada', 'USA', 'China', 'Sweden'],
    correctAnswer: 'Canada',
  },
  {
    question: 'How long do elephant pregnancies last?',
    possibleAnswers: ['24 months', '12 months', '22 months', ' 17 months'],
    correctAnswer: '22 months',
  },
  {
    question: 'Which of these is not a peripheral, in computer terms?',
    possibleAnswers: ['Keyboard', 'Monitor', 'Mouse', 'Motherboard'],
    correctAnswer: 'Motherboard',
  },
  {
    question: 'One Terabyte (1 TB) is equal to:',
    possibleAnswers: ['1028 GB', '1012GB', '1000 GB', '1024 GB'],
    correctAnswer: '1024 GB',
  },
  {
    question: 'What technology is used to record cryptocurrency transactions?',
    possibleAnswers: ['Blockchain', 'Digital Wallet', 'Mining', 'Token'],
    correctAnswer: 'Blockchain',
  },
  {
    question: 'Which one is the first web browser invented in 1990?',
    possibleAnswers: ['Internet Explorer', 'Mosaic', 'Mozilla', 'Nexus'],
    correctAnswer: 'Nexus',
  },
  {
    question: 'Which of the following is not a database management software?',
    possibleAnswers: ['MySQL', 'Oracle', 'Sybase', 'COBOL'],
    correctAnswer: 'COBOL',
  },
  {
    question: 'Who is known as the father of internet',
    possibleAnswers: [
      'Alan Perlis',
      'Jean E. Sammet',
      'Vint Cerf',
      'Steve Lawrence',
    ],
    correctAnswer: 'Vint Cerf',
  },
  {
    question: 'Which one is the first fully supported 64-bit operating system?',
    possibleAnswers: ['Windows Vista', 'Mac', 'Linux', 'Windows XP'],
    correctAnswer: 'Linux',
  },
  {
    question: 'Which one is volatile memory in a computer system?',
    possibleAnswers: ['HardDisk', 'RAM', 'ROM', 'Optical Drive'],
    correctAnswer: 'RAM',
  },
];
